import * as ActiveStorage from 'activestorage'
ActiveStorage.start();

document.addEventListener("direct-upload:initialize", function(event) {
  const { target, detail } = event
  const { id, file } = detail
  target.insertAdjacentHTML("beforebegin", `
    <div id="direct-upload-${id}" class="direct-upload direct-upload--pending">
      <div id="direct-upload-progress-${id}" class="direct-upload__progress" style="width: 0%"></div>
      <span class="direct-upload__filename">${file.name}</span>
    </div>
  `)
})
 
document.addEventListener("direct-upload:start", function(event) {
  const { id } = event.detail
  const element = document.getElementById(`direct-upload-${id}`)
  element.classList.remove("direct-upload--pending")
})
 
document.addEventListener("direct-upload:progress", function(event) {
  const { id, progress } = event.detail
  const progressElement = document.getElementById(`direct-upload-progress-${id}`)
  progressElement.style.width = `${progress}%`
})
 
document.addEventListener("direct-upload:error", function(event) {
  event.preventDefault()
  const { id, error } = event.detail
  const element = document.getElementById(`direct-upload-${id}`)
  element.classList.add("direct-upload--error")
  element.setAttribute("title", error)
})
 
document.addEventListener("direct-upload:end", function(event) {
  const { id } = event.detail
  const element = document.getElementById(`direct-upload-${id}`)
  element.classList.add("direct-upload--complete")
})

document.addEventListener('DOMContentLoaded', function() {
  $("input[type=file]").on("change", function() {
    if(this.files[0].size > 52428800)
    {
      alert(I18n.t('activerecord.errors.models.document.attributes.file.too_big'));
      this.value = ''; 
    }

  });
})